<template>
  <Popup
    :style="{ height: '60%' }"
    @close="$emit('close')"
    class="popup"
    position="bottom"
    v-model="isShow"
  >
    <div class="sku-details" v-if="currentSku">
      <a @click="$emit('close')" class="close" href="javascript:;">关闭</a>
      <div class="sku-intro van-hairline--bottom">
        <div class="sku-img van-hairline--surround">
          <img v-lazy="currentSku.pic_url" />
        </div>

        <div class="sku-price-wrapper">
          <div class="member-price">
            <sku-price :sku="currentSku"></sku-price>
          </div>
          <div class="market-price">
            <del>¥ {{ currentSku.market_price }}</del>
          </div>
        </div>
      </div>
      <div class="sku-details-wrapper">
        <div class="sku-standard">
          <span>规格</span>
          <switch-tab
            :sku-list="skuList"
            @change="switchChange"
            class="standard-tab"
          ></switch-tab>
        </div>
        <div class="sku-num">
          <span>购买数量</span>
          <div class="sku-tips" v-if="currentSku">
            <span class="tips" v-if="currentSku.lowest_buy > 1"
              >( {{ currentSku.lowest_buy }}件起购 )</span
            >
            <Stepper
              :step="type === 'half_price' ? 2 : 1"
              :min="currentSku.lowest_buy || (type === 'half_price' ? 2 : 1)"
              :button-size="20"
              :disable-input="false"
              :input-width="37"
              :integer="true"
              class="check-sku-stepper"
              v-model="count"
              @overlimit="
                disabledEvent(
                  currentSku.activity && currentSku.activity.rule.code,
                  currentSku.lowest_buy
                )
              "
            ></Stepper>
          </div>
        </div>
      </div>
    </div>
    <button :disabled="!goodsInventoryStatus" @click="onConfrime" class="sure">
      确认
    </button>
  </Popup>
</template>

<script>
import { Popup, Stepper } from 'vant'
import SkuPrice from './SkuChoosePrice'
import SwitchTab from './SkuChooseTab'
import { mapState } from 'vuex'
export default {
  name: 'skuChoose',
  components: {
    Popup,
    SkuPrice,
    SwitchTab,
    Stepper
  },
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    sku: {
      type: Object
    },
    status: {
      type: [String]
    },
    goodsInventoryStatus: {
      type: Boolean
    },
    type: {
      type: [String, Number]
    }

  },
  data () {
    return {
      isShow: false,
      count: 1
    }
  },
  computed: {
    ...mapState('store', ['currentSku']),
    skuList () {
      return this.sku.sku_list
    }
  },
  watch: {
    show (newVal) {
      this.isShow = newVal
    }
  },

  methods: {
    disabledEvent (ruleCode, count) {
      if (ruleCode === 'half_price') {
        if (count <= 2) {
          this.$toast('至少购买两件')
        }
      } else {
        this.$toast(`至少购买${count}件`)
      }
    },
    switchChange () {
      this.count = 1
      this.$emit('switch-sku')
    },
    onConfrime () {
      if (this.status === 'add') {
        this.$emit('add-cart', { count: this.count })
      } else if (this.status === 'buy') {
        this.$emit('buy-clicked', { count: this.count })
      } else if (this.status === 'gift') {
        this.$emit('send-gift', { count: this.count })
      }
    }
  }
}
</script>
<style>
</style>
<style lang="less">
.check-sku-stepper {
  .van-stepper__minus,
  .van-stepper__plus {
    width: 0.5rem !important;
    height: 0.5rem !important;
    background-color: transparent;
    border-radius: 50%;
    border: 0.02rem solid #d5d5d5;
  }
  .van-stepper__minus--disabled,
  .van-stepper__plus--disabled {
    color: #d5d5d5;
  }
  .van-stepper__minus:active,
  .van-stepper__plus:active,
  .van-stepper__input[disabled] {
    background-color: transparent;
  }
  .van-stepper__input[disabled] {
    color: #484848 !important;
    -webkit-text-fill-color: #484848;
    -webkit-opacity: 1;
    opacity: 1;
    background-color: transparent;
  }
  .van-stepper__input {
    font-size: @fz28;
    color: #484848 !important;
    background-color: transparent;
  }
}
</style>
<style lang="less" scoped>
.popup {
  overflow-y: unset;
}
.sku-details {
  padding: 0 0.22rem;
  position: relative;
  .close {
    position: absolute;
    right: 0.3rem;
    top: 0.2rem;
    width: 0.74rem;
    height: 0.4rem;
    font-size: @fz20;
    color: @c80;
    border: 0.5px solid #dfdfdf;
    border-radius: 30px;
    z-index: 999;
    .flex-center;
  }
  .sku-intro {
    display: flex;
    padding-bottom: 0.24rem;
    .sku-img {
      margin-top: -1rem;
      width: 2.2rem;
      height: 2.2rem;
      background-color: #f9f9f9;
    }
    .sku-price-wrapper {
      font-size: @fz20;
      .flex-column;
      justify-content: space-around;
      margin-left: 0.2rem;
      .member-price {
        .flex-center;
      }
      em {
        font-weight: 660;
        font-size: @fz32;
      }
      span {
        font-size: @fz28;
        color: @base;
      }
    }
  }
  .sku-details-wrapper {
    height: 5rem;
    .auto;
  }
  .sku-standard {
    padding: 0.25rem 0;
    font-size: @fz28;
    color: @base;
    .flex-column;
    .standard-tab {
      margin: 0.2rem 0;
    }
  }
  .sku-num {
    font-size: @fz28;
    color: @base;
    .flex-between;
    .sku-tips {
      .flex-center;
      .tips {
        color: #ff3824;
        margin-right: 0.2rem;
      }
    }
  }
}
.sure {
  position: absolute;
  left: 50%;
  bottom: 0.2rem;
  transform: translateX(-50%);
  width: 7.03rem;
  height: 0.92rem;
  border-radius: 30px;
  font-size: @fz34;
  color: #fff;
  background-color: #ff3824;
  &:disabled {
    background-color: #ccc;
  }
}
</style>
